<template>
  <div style="width: 100%;text-align: center;">
    <table id="member_list_table" class="table table-bordered">
        <thead>
        <tr>
          <th v-for="(item, index) in headList"
              v-if="!(hideForSmallScreen && (index == 4 || index == 3 || index == 5))"
              :key="'org_table_header_' + index"
              style="min-width: 69px;padding-left: 0;padding-right: 0;"
          >{{item}}</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in memberList" :key="'org_table_tr_' + index" >
          <td><a :href="memberSrc(item.id)">{{item.certificateNo == null ? '暂无' : item.certificateNo}}</a></td>
          <td><a :href="memberSrc(item.id)">{{item.typeName == null ? '暂无' : item.typeName}}</a></td>
          <td><a :href="memberSrc(item.id)" v-html="memberNameText(item)"></a></td>
    <!--      <td v-if="!hideForSmallScreen"><a :href="memberSrc(item.id)">{{(item.enterprise == null || item.enterprise == '') ? '—' : item.enterprise}}</a></td>-->
          <td v-if="!hideForSmallScreen"><a :href="memberSrc(item.id)">{{memberIssueDate(item)}}</a></td>
          <td v-if="!hideForSmallScreen"><a :href="memberSrc(item.id)">{{memberValidDate(item)}}</a></td>
        </tr>
        </tbody>
      </table>

      <loading-view v-if="showBottomLoading" :index="loadingIndex" />
  </div>
</template>

<script>
  import BottomLoadingView from "../common/BottomLoading.vue";
export default {
  name: "MemberList",
  components: {
    'loading-view': BottomLoadingView,
  },
  data() {
    return {
      title: '会员列表',
      headList: [
        '证书编号',
        '会员类别',
        '会员名称',
        // '代表企业',
        '证书颁布日期',
        '证书有效期至'
      ],
      memberList: null,
      pageIndex: 1,
      pageSize: 10,
      isLoading: false,
      hideForSmallScreen: true,
      showBottomLoading: false,
      loadingIndex: 0,
      isFirstLoading: false,
    }
  },
  computed: {
    memberPath() {
      return this.$route.path;
    }
  },
  mounted() {
    this.loadData();
    let _this = this;

    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 50);

    window.onscroll = this.scrollListener;
  },

  destroyed() {
    document.removeEventListener('mousewheel', this.scrollListener);
  },

  methods: {
    memberNameText(user) {
      let nameText = '暂无';

      let typeName = user.typeName;
      let isTeam = user.isTeam;

      if (typeName == '个人会员') {
        let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
        nameText = name;
      } else if (typeName == '团体会员') {
        // let contacts = user.contacts;
        // if (contacts != null && contacts.length > 0) {
        //   nameText =  contacts;
        //   let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
        //   nameText += '<br>' +  '（' + name + '）';
        // } else {
        //   let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
        //   nameText = name;
        // }

        let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
        nameText = name;
      } else if (typeName == '理事') {
        // console.log('---2');
        if (isTeam) {
          let contacts = user.contacts;
          if (contacts != null && contacts.length > 0) {
            nameText =  contacts;
          }
          if (nameText != '暂无') {
            nameText += '<br>'
          }

          let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
          nameText += '（' + name + '）';
        } else {
          let name = (user.name == null != user.name.length == 0) ? user.nickname : user.name;
          nameText = name;
          let enterprise = user.enterprise;
          if (enterprise != null && enterprise.length > 0) {
            nameText += '<br>' + '（' + enterprise + '）';
          }
        }
      } else {
        let name = (user.name == null != user.name.length > 0) ? user.nickname : user.name;
        nameText = name;
        let enterprise = user.enterprise;
        // console.log(enterprise);
        if (enterprise != null && enterprise.length > 0) {
          nameText += '<br>' + '（' + enterprise + '）';
        }
      }
      return nameText;
    },

    scrollListener() {
      if ( this.getScrollTop() + this.getClientHeight() + 50 - this.getScrollHeight() > 20 && !this.isLoading) {
        // // console.log('下拉刷新!');
        this.pageIndex ++;
        this.loadData();
      }
    },

    updateStatus() {
      let tableWitdh = $('#member_list_table').width();
      if (tableWitdh >= 600) {
        this.hideForSmallScreen = false
      } else  {
        this.hideForSmallScreen = true
      }
    },

    memberSrc(userId) {
      let url = '/introduce/'
      let id = this.$route.params.id;
      url += id + '/detail/' + userId;

      return url;
    },
    loadData() {
      if (this.isLoading || this.loadingIndex == 2) {
        return;
      }

      let pageIndex = this.pageIndex;
      let params = {
        pageIndex,
        size: this.pageSize
      }
      this.isLoading = true;
      if (!this.isFirstLoading) {
        this.showBottomLoading = true;
        this.loadingIndex = 1;
      } else {
        this.showBottomLoading = false;
      }

      let _this = this;
      this.$store.state.http.ajax.userGetListPager(params, function (data) {
        if (!_this.showBottomLoading) {
          _this.showBottomLoading = true;
        }
        _this.isLoading = false;
        let code = data.code;

        if (code == 0) {
          let memberList = data.data;
          if (memberList.length > 0) {
            if (pageIndex == 1) {
              _this.memberList = memberList;
            } else {
              _this.memberList = _this.memberList.concat(memberList);
            }

            if (memberList.length == _this.pageSize) {
              _this.loadingIndex = 0;
            } else {
              _this.loadingIndex = 2;
            }
          } else {
            _this.loadingIndex = 2;
            if (pageIndex > 1) {
              pageIndex --;
              _this.pageIndex = pageIndex;
            }
          }
        } else {
          _this.loadingIndex = 0;
          if (pageIndex > 1) {
            pageIndex --;
            _this.pageIndex = pageIndex;
          }
        }
      }, function (data) {
        _this.loadingIndex = 0;
        _this.isLoading = false;
        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
        }
      })
    },

    memberTypeText(item) {
      // console.log(item);
      let typeText = '暂无';
      if (item == null) {
        return typeText;
      }

      let typeName = item.typeText;

      let type = item.type;

      if (type == null) {
        return typeText;
      }

      typeText = item.typeName;

      return typeText;
    },

    memberValidDate(item) {
      let validDate = this.$moment(item.memberValidDate);
      if (validDate.isValid()) {
        return validDate.format('yyyy.MM.DD');
      }
      return '暂无';
    },

    memberIssueDate(item) {
      let validDate = this.$moment(item.memberValidDate);
      if (validDate.isValid()) {
        let issueDate = validDate.add(-1, 'years');
        issueDate.add('1', 'days');
        return issueDate.format('yyyy.MM.DD');
      }

      return '暂无';
    },

    //获取滚动条当前的位置
    getScrollTop() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    //获取当前可视范围的高度
    getClientHeight() {
      let clientHeight = 0;
      if(document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    }

}
}
</script>

<style scoped>

  #member_list_table {
    width: 100%;
  }
  #member_list_table thead tr {
    background-color: #f6f6f6;
  }

  #member_list_table thead th {
    color: #333;
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  #member_list_table tbody td {
    text-align: center;
    vertical-align: middle;
  }

  #member_list_table tbody td > a {
    color: #333;
    font-size: 1.3rem;
    text-decoration: none;
  }

  #member_list_table tbody td > a:hover {
    color: #fc1a34;
   }


</style>



// WEBPACK FOOTER //
// src/components/introduce/MemberList.vue